<template>
  <div class="page-content delivery-orders">
    <div class="row search-form">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="sections">
              <p-button
                type="purple"
                :class="{ active: status.section === orderTabs.search }"
                @click="clickSearchButton"
              >
                Search
              </p-button>
              <p-button
                type="purple"
                :class="{ active: status.section === orderTabs.active }"
                @click="loadOrders(1, orderTabs.active)"
              >
                Active
              </p-button>
              <p-button
                type="purple"
                :class="{ active: status.section === orderTabs.inactive }"
                @click="loadOrders(1, orderTabs.inactive)"
              >
                Inactive
              </p-button>
              <p-button
                type="purple"
                :class="{ active: status.section === orderTabs.unresolved }"
                @click="loadOrders(1, orderTabs.unresolved)"
              >
                Unresolved
              </p-button>
            </div>

            <form
              v-show="status.section === orderTabs.search"
              v-loading="status.loading"
              method="post"
              class="search form-vertical"
              element-loading-text="Loading Orders..."
              element-loading-custom-class="custom-spinner-class"
              autocomplete="off"
              @submit.prevent="loadOrders(1, orderTabs.search)"
            >
              <div class="row align-items-center customer-phone">
                <div class="offset-2 col-sm-3">
                  <dropdown-list
                    v-model="searchCondition.queryType"
                    :options="queryTypeList"
                    :disabled="status.loading"
                  />
                </div>
                <div class="col-sm-5">
                  <sanitized-input
                    v-if="!isPhoneSearch && !isServiceSearch"
                    v-model="searchCondition.queryInfo"
                    placeholder="Query"
                    required
                  />
                  <phone-number-input
                    v-if="isPhoneSearch"
                    v-model="searchCondition.queryInfo"
                    page-id="delivery-orders-phone-search"
                    :required="true"
                  />
                  <dropdown-list
                    v-if="isServiceSearch"
                    v-model="searchCondition.queryInfo"
                    :options="gourmetServiceList"
                    :disabled="status.loading"
                  />
                </div>
              </div>
              <div class="row align-items-center">
                <div class="offset-5 col-sm-5">
                  <date-picker
                    v-model="timeSpanValue"
                    type="daterange"
                  >
                    <template #comment>
                      <span class="help-block"> Please click the same day twice if you only want results from that particular day </span>
                    </template>
                  </date-picker>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="offset-5 col-sm-5 row">
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isPlaced"
                      v-model="orderStatus.isPlaced"
                    >
                      Placed
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isPreparing"
                      v-model="orderStatus.isPreparing"
                    >
                      Preparing
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isDeliverying"
                      v-model="orderStatus.isDeliverying"
                    >
                      Deliverying
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isCompleted"
                      v-model="orderStatus.isCompleted"
                    >
                      Completed
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isCanceled"
                      v-model="orderStatus.isCanceled"
                    >
                      Canceled
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isError"
                      v-model="orderStatus.isError"
                    >
                      Error
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isResolved"
                      v-model="orderStatus.isResolved"
                    >
                      Resolved
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isResolved"
                      v-model="orderStatus.isSaved"
                    >
                      Saved
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isScheduled"
                      v-model="orderStatus.isScheduled"
                    >
                      Scheduled
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isRedelivery"
                      v-model="orderStatus.isRedelivery"
                    >
                      Redelivery
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isBistro"
                      v-model="orderStatus.isBistro"
                    >
                      Bistro
                    </el-checkbox>
                  </div>
                  <div class="col-sm-4 checkbox-container">
                    <el-checkbox
                      id="isIvr"
                      v-model="orderStatus.isIvr"
                    >
                      IVR
                    </el-checkbox>
                  </div>
                </div>
              </div>
              <div class="form-submit-button-group">
                <p-button
                  type="purple"
                  native-type="submit"
                  :disabled="isDisabledSearch"
                >
                  Search
                </p-button>
                <p-button
                  type="yellow"
                  @click="clearSearch"
                >
                  Clear
                </p-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <pagination
      v-if="orders.length"
      :current-page="status.currentPage"
      :total-pages="status.totalPages"
      @load-page-data="loadOrders"
    />
    <div
      v-loading="status.loading"
      element-loading-text="Loading Orders..."
      element-loading-custom-class="custom-spinner-class"
    >
      <div
        v-for="(order, index) in orders"
        id="orders"
        :key="index"
        class="row"
      >
        <div class="col-12">
          <div class="card">
            <div
              v-loading="orderInfo.loading && orderInfo.orderId === order.id"
              class="card-body"
              :element-loading-text="orderInfo.message"
              element-loading-custom-class="custom-spinner-class"
            >
              <div class="card-title">
                <div class="row">
                  <div class="col-8">
                    <div class="item-title h6">
                      <a
                        href="#"
                        @click="toggleOrder(order.id)"
                      >{{ order.storeOrder.title }}&nbsp;<i
                        class="el-collapse-item__arrow el-icon-arrow-right"
                        :class="{ 'is-active': expandedOrders.includes(order.id) }"
                      /></a>
                    </div>
                    <div>
                      <strong>Client:</strong> {{ order.caller.firstName }} {{ order.caller.lastName }} ({{ order.caller.phoneNumber }})
                    </div>
                    <div v-if="order.clientName || order.preferredPhoneNumber">
                      <strong>Best Contact:</strong> {{ order.clientName }} ({{ order.preferredPhoneNumber }})
                    </div>
                    <div>
                      <strong>Address:</strong>
                      {{ order.storeOrder.estimate.address && order.storeOrder.estimate.address.formattedAddress }}
                    </div>
                    <div>
                      <strong>Address 2:</strong>
                      {{ order.storeOrder.estimate.address && order.storeOrder.estimate.address.streetAddress2 }}
                    </div>
                    <div v-if="order.serviceAccount">
                      <strong>Service:</strong> {{ order.service }} - {{ order.serviceAccount.email }} ({{
                        order.serviceAccount.phoneNumber
                      }})
                    </div>
                    <div v-if="order.orderStatus.agent && order.orderStatus.agent.name && order.orderStatus.agent.phoneNumber">
                      <strong>Driver:</strong> {{ order.orderStatus.agent.name }} ({{ order.orderStatus.agent.phoneNumber }}) -
                      <router-link :to="getPathForDeliveryCall(order)">
                        <strong>Call</strong>
                      </router-link>
                      -
                      <router-link
                        :to="getPathForDeliverySMS(order)"
                        target="_blank"
                      >
                        <strong>SMS</strong>
                      </router-link>
                    </div>
                    <div><strong>Placed:</strong> {{ utils.formatDateTime(order.createdAt, 'YYYY-MM-DD [at] h:mm a') }}</div>
                    <div><strong>Ordered By:</strong> {{ getOrderedBy(order) }}</div>
                    <div>
                      <strong>Operator:</strong> {{ order.operator ? order.operator.firstName : '' }}
                      {{ order.operator ? order.operator.lastName : '' }}
                    </div>
                    <div>
                      <strong>Membership Type:</strong> {{ utils.normalizePlanName(order.storeOrder?.estimate?.chargeOptions?.plan ?? '') }}
                    </div>
                    <div v-if="order.needLoveId">
                      <strong>Need Love:</strong> {{ order.needLoveId }}
                    </div>
                    <div
                      v-if="order.status === 'complete'"
                      class="checkbox-container mt-2"
                    >
                      <el-checkbox
                        id="isPlaced"
                        v-model="order.isNotReceivedOrder"
                        :disabled="!hasSpecialPermission"
                        @change="onChangeNotReceivedOrder(order.id, $event)"
                      >
                        Did not received order {{ order.transactionId && order.paidStatus === 'paid' ? '/Gave full refund' : '' }}
                      </el-checkbox>
                    </div>
                  </div>
                  <div class="col-4 order-status-info">
                    <div>
                      <el-progress
                        class="mb-2"
                        :show-text="false"
                        :stroke-width="13"
                        :percentage="order.orderStatus.currentProgress * 100"
                      />
                      <div>
                        <strong>Status:</strong>&nbsp;<span class="capitalize">{{ order.orderStatus.title }}</span>
                      </div>
                      <div><strong>Info:</strong> {{ order.orderStatus.description }}</div>
                      <div><strong>Location Address:</strong> {{ getStoreAddress(order) }}</div>
                      <div><strong>Location Phone Number:</strong> {{ getStorePhone(order) }}</div>
                      <div>
                        <strong>Estimate:</strong> {{ order.storeOrder.estimate.timeEstimate.min }} -
                        {{ order.storeOrder.estimate.timeEstimate.max }} min
                      </div>
                      <div v-if="order.rateInfo">
                        <div
                          v-for="(rate, rIndex) in order.rateInfo.rateList"
                          :key="rIndex"
                          class="rate-container"
                        >
                          <strong>{{ rate.target?.targetType === GourmetRateTarget.Store ? 'Store: ' : 'Driver: ' }}</strong>
                          <el-rate
                            v-model="rate.starRating"
                            disabled
                            size="large"
                          />
                        </div>
                      </div>
                      <div v-else-if="order.status === 'complete'">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="Rate Store and Driver"
                          placement="bottom-end"
                        >
                          <i
                            class="fa fa-star order-rate-icon"
                            @click="showRateDeliveryOrder(order)"
                          />
                        </el-tooltip>
                      </div>
                    </div>
                    <div v-if="hasUnsuccessfullyStatus(order) || isResolvedWithoutReOrder(order)">
                      <div v-if="!isResolvedWithReOrder(order) && !isResolvedWithoutReOrder(order)">
                        <strong class="orderBadge unresolvedOrderBudge">Unresolved</strong>
                      </div>
                      <div v-if="isResolvedWithReOrder(order) || isResolvedWithoutReOrder(order)">
                        <strong class="orderBadge resolvedOrderBudge">Resolved</strong>
                      </div>
                    </div>
                    <div v-if="isRedeliveryWithReOrder(order)">
                      <strong class="orderBadge resolvedOrderBudge">Redelivery</strong>
                    </div>
                    <div v-if="isAllowToManage">
                      <el-tooltip
                        v-if="order.status === 'complete'"
                        class="item"
                        effect="dark"
                        content="Send a Receipt"
                        placement="bottom-end"
                      >
                        <i
                          class="fa fa-paper-plane send-receipt-icon"
                          @click="onSendReceipt(order)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Submit Need Love"
                        placement="bottom-end"
                      >
                        <i
                          class="fa fa-heart need-love-icon"
                          @click="submitNeedLove(order)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        v-if="order.transactionId && order.paidStatus === 'paid'"
                        class="item"
                        effect="dark"
                        content="Refund"
                        placement="bottom-end"
                      >
                        <i
                          class="fa fa-dollar refund-icon"
                          @click="openRefund(order)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Redelivery"
                        placement="bottom-end"
                      >
                        <i
                          class="fa fa-car redelivery-icon"
                          @click="redeliveryOrder(order)"
                        />
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div
                  v-show="
                    expandedOrders.includes(order.id) && order.orderStatus.locationMarkers && order.orderStatus.locationMarkers.length
                  "
                  class="row map-container"
                >
                  <div class="col-12">
                    <go-go-google-map
                      v-if="order.orderStatus.locationMarkers && order.orderStatus.locationMarkers.length"
                      :markers="getMapMarkers(order.orderStatus.locationMarkers)"
                      :map-center="getMapCenter(order.orderStatus.locationMarkers)"
                      :is-draggable="true"
                      :is-open-default="true"
                      :zoom="14"
                    />
                  </div>
                </div>
                <div
                  v-show="expandedOrders.includes(order.id)"
                  class="row border-top"
                >
                  <div class="col-4">
                    <strong>Order ID:</strong> {{ order.id }}
                  </div>
                  <div class="col-4">
                    <strong>Order Link: </strong>
                    <a
                      class="copy-link"
                      @click="copyOrderLink(order)"
                    >{{ order.orderId }}</a>
                  </div>
                  <div class="col-4">
                    <strong>Updated:</strong> {{ utils.formatDateTime(order.updatedAt, 'YYYY-MM-DD [at] h:mm a') }}
                  </div>
                  <div class="col-8">
                    <div v-if="deliveryInstructionsInfo.isUpdatingDeliveryInstructions && orderInfo.orderId === order.id">
                      <div class="instructions-info">
                        <strong>Delivery Instructions*</strong>
                        <sanitized-textarea
                          id="notes"
                          v-model="deliveryInstructionsInfo.deliveryInstructions"
                          placeholder="Please input the notes"
                          autosize
                          required
                        />
                      </div>
                      <div class="instructions-info mt-2">
                        <strong>Drop-off Options*</strong>
                        <dropdown-list
                          v-model="deliveryInstructionsInfo.dropoffOptionId"
                          :options="dropOffTypeList"
                        />
                      </div>
                      <div class="mt-2">
                        <p-button
                          type="success"
                          @click="updateDeliveryInstructions"
                        >
                          Update
                        </p-button>
                        <p-button
                          type="danger"
                          @click="clearDeliveryInstructions"
                        >
                          Cancel
                        </p-button>
                      </div>
                    </div>
                    <div v-else>
                      <div>
                        <strong>Delivery Instructions:</strong>
                        {{ order.storeOrder.estimate.orderOptions && order.storeOrder.estimate.orderOptions.deliveryInstructions }}
                      </div>
                      <div class="mt-2">
                        <strong>Drop-off Options:</strong>
                        {{ getDropOffName(order?.storeOrder?.estimate?.orderOptions?.dropoffOptionId ?? '') }}
                      </div>
                      <div
                        v-if="enabledEditDeliveryInstructions(order)"
                        class="mt-2"
                      >
                        <p-button
                          type="success"
                          @click="editDeliveryInstructions(order)"
                        >
                          Edit
                        </p-button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="order.caller.isRequiredMonitoringGourmetOrder"
                    class="col-4"
                  >
                    <el-checkbox
                      id="isConfirmedMonitoringCall"
                      v-model="order.isConfirmedMonitoringCall"
                      :disabled="!orderTabs.active"
                      @change="onUpdateConfirmedMonitoringCall($event, order)"
                    >
                      Driver Confirmed Requires Monitoring Call
                    </el-checkbox>
                  </div>
                </div>
                <div
                  v-show="expandedOrders.includes(order.id)"
                  class="row border-top"
                >
                  <div class="col-8 order-details-info">
                    <div>
                      <h6>Items</h6>
                      <div
                        v-if="!detailedOrders[order.id]"
                        v-loading="!detailedOrders[order.id]"
                        class="order-options-preloader"
                      />
                      <ol
                        v-if="detailedOrders[order.id]"
                        class="items-list"
                      >
                        <li
                          v-for="(item, itemIdx) in detailedOrders[order.id].storeOrder.estimate.items"
                          :key="itemIdx"
                        >
                          {{ item.item?.title }}(Quantity: {{ item.item?.quantity || 1 }}) - ${{
                            ((item.item?.price ?? 0) / 100).toFixed(2)
                          }}
                          <order-options :options="getOptions(item.options)" />
                        </li>
                      </ol>
                    </div>
                    <br>
                    <div
                      v-if="order.isRedelivery && (order.natureOfComplaint || order.originalOrderId)"
                      class="redelivery-section"
                    >
                      <p v-if="order.natureOfComplaint">
                        This order is a Redelivery for {{ order.natureOfComplaint }}
                      </p>
                      <p v-if="order.originalOrderId">
                        The following order was resolved by this order:
                        <router-link :to="getPathForOriginalOrder(order)">
                          Order Id: {{ order.originalOrderId }}
                        </router-link>
                      </p>
                    </div>
                    <delivery-order-buttons
                      v-if="isAllowToManage"
                      :order="order"
                      :is-allow-to-mark-order="hasSpecialPermission"
                      @resolve-order-without-reorder="doResolveOrderWithoutReorder"
                      @mark-order-as-canceled="markOrderAsCanceled"
                      @mark-order-as-completed="markOrderAsCompleted"
                      @mark-order-as-do-not-charge="markOrderAsDoNotCharge"
                    />
                  </div>
                  <div class="col-4">
                    <h6>Receipt (${{ ((order.total ?? 0) / 100).toFixed(2) }})</h6>
                    <div
                      v-for="(charge, chargeIdx) in order.storeOrder.estimate.charges"
                      :key="chargeIdx"
                      class="charge-item"
                    >
                      <span class="charge-title">{{ charge.title }}
                        <el-tooltip
                          v-if="charge.tooltips && charge.tooltips.length > 0"
                          placement="bottom"
                        >
                          <template #content>
                            <div id="charge-tooltip-content">
                              <div
                                v-for="(tooltip, tooltipIndex) in charge.tooltips"
                                :key="tooltipIndex"
                              >
                                <div
                                  v-if="tooltip.title"
                                  class="tooltip-title"
                                >
                                  {{ tooltip.title }}
                                </div>
                                <div
                                  class="tooltip-value"
                                  v-text="tooltip.value"
                                />
                              </div>
                            </div>
                          </template>
                          <i class="fa fa-info charge-info" />
                        </el-tooltip>
                      </span>
                      <span
                        v-if="charge.originalValue"
                        class="charge-origial-value"
                      >${{ (charge.originalValue / 100).toFixed(2) }} </span>${{ (charge.value / 100).toFixed(2) }}
                    </div>
                    <div
                      v-if="getClientSavings(order) > 0"
                      class="charge-item"
                    >
                      <span class="charge-title">Client Savings: </span>${{ getClientSavings(order).toFixed(2) }}
                    </div>
                    <div
                      v-if="getRefunds(order) > 0"
                      class="charge-item refund-item"
                    >
                      <span class="charge-title">Gourmet Refund: </span>${{ getRefunds(order).toFixed(2) }}
                    </div>
                    <br>
                    <div v-if="order.orderCharge">
                      <h6>
                        Charges (${{ (order.orderCharge.total / 100).toFixed(2) }} -
                        {{ order.orderCharge.card.complete && order.orderCharge.credits.complete ? 'Complete' : 'Pending' }})
                      </h6>
                      <div
                        v-if="order.orderCharge.expiringCredits"
                        class="charge-item"
                      >
                        <span class="charge-title">GoGo Expiring Credits ({{ order.orderCharge.expiringCredits.complete ? 'Complete' : 'Pending' }}): </span>${{ (order.orderCharge.expiringCredits.total / 100).toFixed(2) }}
                      </div>
                      <div class="charge-item">
                        <span class="charge-title">GoGo Credits ({{ order.orderCharge.credits.complete ? 'Complete' : 'Pending' }}): </span>${{ (order.orderCharge.credits.total / 100).toFixed(2) }}
                      </div>
                      <div class="charge-item">
                        <span class="charge-title">Credit Card ({{ order.orderCharge.card.complete ? 'Complete' : 'Pending' }}): </span>${{
                          (order.orderCharge.card.total / 100).toFixed(2)
                        }}
                      </div>
                    </div>
                    <div
                      v-if="order.orderCharge && order.orderCharge.card.cardLast4"
                      class="mt-20"
                    >
                      <h6>Credit Card Number (last 4 digits): {{ `*${order.orderCharge.card.cardLast4}` }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination
        v-if="orders.length"
        :current-page="status.currentPage"
        :total-pages="status.totalPages"
        @load-page-data="loadOrders"
      />
      <div
        v-if="!orders.length && !status.loading"
        class="center"
      >
        <h3>No orders to show</h3>
      </div>
    </div>
    <rate-delivery-order
      :is-show-dialog="isShowRatingDialog"
      :rate-data="orderRateData"
      @cancel="isShowRatingDialog = false"
      @submit="onSubmitRate"
    />
    <delivery-order-refund
      :is-show-dialog="isShowRefundDeliveryOrder"
      :transaction-id="refundTransactionId"
      :delivery-order-id="orderInfo.orderId"
      @cancel="isShowRefundDeliveryOrder = false"
    />
  </div>
</template>

<script lang="ts">
import { ref, Ref, reactive, onMounted, onBeforeUnmount, watch, toRefs, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { get } from 'lodash';
import queryString from 'query-string';

import utils from '@/Utils/util';
import { useProfile } from '@/use/profile';
import { useSwalDialog } from '@/use/swalDialog';
import { useGourmet } from '@/use/gourmet';
import { useCustomer } from '@/use/customer';
import { GourmetRateTarget, GourmetVendor } from '@/models/deliveryOrder';
import { ListType, PaginationInput } from '@/models/app';
import { GeoLocationType } from '@/models/address';
import { DeliveryOrder, DeliveryOrderLocationMarker, OrderRateData } from '@/models/gourmet';
import { dropOffTypeList, gourmetServiceList, orderTabs } from '@/constants/deliveryOrder';
import { sendPost } from '@/Utils/api';
import { gourmetService } from '@/services/gourmet';
import { OrderRateListInput } from '@/gql/graphql';

import OrderOptions from '../../UIComponents/OrderingForms/OrderOptions.vue';
import DeliveryOrderButtons from '@/components/Main/Operator/Delivery/DeliveryOrderButtons.vue';
import Pagination from '@/components/UIComponents/Pagination.vue';
import RateDeliveryOrder from '../Dialogs/RateDeliveryOrder.vue';
import DeliveryOrderRefund from '../Dialogs/DeliveryOrderRefund.vue';

const ivrOperatorId = 'ca26750e-0d1f-4c44-9cbc-7d78dc7b9fd1';
const updateDelay = 2000;
const paginationLimit = 5;
const queryTypeList: ListType[] = [
  { id: 1, key: 'id', label: 'Order ID' },
  { id: 2, key: 'callerId', label: 'Caller ID' },
  { id: 3, key: 'callerPhone', label: 'Caller Phone' },
  { id: 4, key: 'operatorId', label: 'Operator ID' },
  { id: 5, key: 'slackId', label: 'Operator Slack ID' },
  { id: 6, key: 'service', label: 'Service Name' },
  { id: 7, key: 'serviceAccountId', label: 'Service Id' },
  { id: 7, key: 'serviceAccountEmail', label: 'Service Email' },
  { id: 8, key: 'address', label: 'Delivery Address' },
  { id: 9, key: 'restaurantName', label: 'Restaurant Name' },
];

export default {
  name: 'DeliveryOrders',

  components: {
    DeliveryOrderButtons,
    OrderOptions,
    RateDeliveryOrder,
    DeliveryOrderRefund,
    Pagination,
  },

  setup: () => {
    const route = useRoute();
    const router = useRouter();
    const { showSuccessPopupDialog, showErrorPopupDialog, showConfirmPopupDialogWithValidation, showConfirmPopupDialog } = useSwalDialog();
    const { setGourmetNeedLoveInfo, showFirstDeliveryPopup, setRedeliveryOrderId } = useGourmet();
    const { userRoles } = useProfile();

    const {
      isAdmin,
      isGourmetSupervisor,
      isDirector,
      isSupervisor,
      isTeamLead,
      isGourmetOperator,
      isLossPreventionGourmet,
      isGroceryOperator,
      isGroceryManager,
    } = toRefs(userRoles);

    const { isNeedToShowFirstDeliveryPopup, customerInfo } = useCustomer();

    const hasSpecialPermission = computed(() => {
      return isAdmin.value || isGourmetSupervisor.value;
    });
    const isAllowToManage = computed(
      () =>
        isAdmin.value ||
        isDirector.value ||
        isSupervisor.value ||
        isTeamLead.value ||
        isGourmetSupervisor.value ||
        isGourmetOperator.value ||
        isLossPreventionGourmet.value ||
        isGroceryOperator.value ||
        isGroceryManager.value,
    );

    const orders: Ref<DeliveryOrder[]> = ref([]);
    const expandedOrders: Ref<string[]> = ref([]);
    const detailedOrders: Ref<{
      [key: string]: DeliveryOrder;
    }> = ref({});
    const interval: Ref<ReturnType<typeof setInterval> | null> = ref(null);
    const timeSpanValue: Ref<any> = ref(null);
    const orderRateData: Ref<OrderRateData[]> = ref([]);
    const isShowRatingDialog = ref(false);
    const isShowRefundDeliveryOrder = ref(false);
    const refundTransactionId = ref('');
    const orderInfo = reactive({
      orderId: '',
      loading: false,
      message: '',
    });
    const deliveryInstructionsInfo = reactive({
      isUpdatingDeliveryInstructions: false,
      deliveryInstructions: '',
      dropoffOptionId: '',
    });
    const searchCondition = reactive({
      queryType: 'callerPhone',
      queryInfo: '',
    });
    const orderStatus = reactive({
      isPlaced: false,
      isPreparing: false,
      isDeliverying: false,
      isCompleted: false,
      isCanceled: false,
      isResolved: false,
      isError: false,
      isSaved: false,
      isScheduled: false,
      isRedelivery: false,
      isBistro: false,
      isIvr: false,
    });
    const status = reactive({
      section: orderTabs.search,
      loading: false,
      currentPage: 1,
      totalPages: 1,
    });
    const pagination = reactive({
      offset: 0,
      limit: paginationLimit,
    });

    const isPhoneSearch = computed(() => searchCondition.queryType === 'callerPhone');
    const isServiceSearch = computed(() => searchCondition.queryType === 'service');
    const isDisabledSearch = computed(() => isPhoneSearch.value && !utils.isPhoneNumberValid(searchCondition.queryInfo));

    const getOrderedBy = (orderInfo: DeliveryOrder) => {
      if (orderInfo.scheduleId) {
        return 'Prescheduled with an Operator';
      }

      if (orderInfo.operatorId === ivrOperatorId) {
        return 'Automated Phone System';
      }

      let suffix = 'Dashboard'

      if (orderInfo?.storeOrder?.isManualOrder) {
        suffix = 'Manual';
      }

      if (orderInfo?.storeOrder?.estimate?.serviceEstimateReference?.source === 'gogo-doordash-extension') {
        suffix = 'Extension';
      }

      return `Operator Order - ${orderInfo.isRedelivery ? `Redelivery (${suffix})` : `On demand (${suffix})`}`;
    };

    const getClientSavings = (orderInfo: DeliveryOrder) => {
      let clientSavings = 0;

      if (orderInfo.storeOrder?.estimate?.chargeOptions?.tier === 'tier1') {
        clientSavings = 2; // diff between tier1 vs tier2
      } else if (orderInfo.storeOrder?.estimate?.chargeOptions?.tier === 'tier3') {
        clientSavings = 3.25; // diff between tier3 vs tier4
      }

      return clientSavings;
    };

    const toggleOrder = async (orderId: string) => {
      const index = expandedOrders.value.indexOf(orderId);

      if (index === -1) {
        expandedOrders.value.push(orderId);
      } else {
        expandedOrders.value.splice(index);
      }

      if (!detailedOrders.value[orderId]) {
        const resp = await getDetailedOrders(
          {
            limit: 1,
            offset: 0,
          },
          orderId,
        );

        if (resp.rows.length) {
          detailedOrders.value[orderId] = resp.rows[0];
        }
      }
    };

    const clickSearchButton = () => {
      orders.value = [];
      status.section = orderTabs.search;
    };

    const loadOrders = async (currentPage: number = 1, section?: string) => {
      status.currentPage = currentPage;
      pagination.offset = (currentPage - 1) * paginationLimit;

      status.loading = true;
      let resp;

      if (section) {
        status.section = section;
      }

      try {
        switch (status.section) {
          case orderTabs.active:
            resp = await gourmetService.getActiveOrders({
              pagination,
            });
            break;

          case orderTabs.inactive:
            resp = await gourmetService.getInactiveOrders(pagination);
            break;

          case orderTabs.unresolved:
            resp = await gourmetService.getUnresolvedOrders(pagination);
            break;

          case orderTabs.search:
            resp = await getSearchOrders(pagination);
        }

        orders.value = resp.rows;
        status.totalPages = Math.ceil(resp.count / paginationLimit);
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
        orders.value = [];
        status.totalPages = 0;
      } finally {
        status.loading = false;
      }
    };

    const clearSearch = () => {
      orders.value = [];
      searchCondition.queryType = 'callerPhone';
      searchCondition.queryInfo = '';
      orderStatus.isPlaced = false;
      orderStatus.isPreparing = false;
      orderStatus.isDeliverying = false;
      orderStatus.isCompleted = false;
      orderStatus.isCanceled = false;
      orderStatus.isResolved = false;
      orderStatus.isError = false;
      orderStatus.isSaved = false;
      orderStatus.isScheduled = false;
      orderStatus.isRedelivery = false;
      orderStatus.isBistro = false;
      orderStatus.isIvr = false;
      status.totalPages = 1;
      timeSpanValue.value = null;
    };

    const getSearchOrders = async (paginationInfo: PaginationInput, id?: string) => {
      const where: any = {};

      if (id) {
        where.id = id;
      } else if (searchCondition.queryInfo) {
        where[searchCondition.queryType] = searchCondition.queryInfo;
      }

      const status: string[] = [];

      if (orderStatus.isPlaced) {
        status.push('placed');
      }

      if (orderStatus.isPreparing) {
        status.push('preparing');
      }

      if (orderStatus.isDeliverying) {
        status.push('delivering');
      }

      if (orderStatus.isCompleted) {
        status.push('complete');
      }

      if (orderStatus.isCanceled) {
        status.push('canceled');
      }

      if (orderStatus.isError) {
        status.push('error');
      }

      if (orderStatus.isSaved) {
        status.push('saved');
      }

      if (orderStatus.isScheduled) {
        status.push('scheduled');
      }

      if (status.length) {
        where.status = status;
      }

      if (orderStatus.isResolved) {
        where.isResolved = true;
      }

      if (orderStatus.isRedelivery) {
        where.isRedelivery = true;
      }

      if (orderStatus.isBistro) {
        where.isBistro = true;
      }

      if (orderStatus.isIvr) {
        where.isIvr = true;
      }

      if (timeSpanValue.value) {
        where.startDate = utils.formatDateTime(timeSpanValue.value[0], 'YYYY-MM-DD');
        where.endDate = utils.formatDateTime(timeSpanValue.value[1], 'YYYY-MM-DD');
      }

      return gourmetService.getOrders({
        where,
        pagination: paginationInfo,
        isSingle: !!id,
      });
    };

    const getDetailedOrders = async (paginationInfo: PaginationInput, id: string) => {
      const where: {
        [key: string]: string;
      } = {};

      if (id) {
        where.id = id;
      } else {
        where[searchCondition.queryType] = searchCondition.queryInfo;
      }

      return gourmetService.getOrders({
        where,
        pagination: paginationInfo,
        isDetail: true,
      });
    };

    const doResolveOrderWithoutReorder = async (orderId: string) => {
      status.loading = true;

      await gourmetService.resolveOrderWithoutReorder(orderId);
      status.loading = false;
      loadOrders(1, orderTabs.unresolved);
    };

    const markOrderAsCanceled = async (orderId: string) => {
      const notes = await showConfirmPopupDialogWithValidation({
        text: `Mark As Canceled Delivery ${orderId}?`,
        title: `Cancel Delivery?`,
        input: 'textarea',
        inputPlaceholder: 'Please input reason',
        validationText: `Please provide the reason for mark delivery as canceled`,
        confirmButtonText: 'Cancel',
      });

      if (!notes) {
        return;
      }

      orderInfo.loading = true;
      orderInfo.orderId = orderId;
      orderInfo.message = 'Marking order as canceled...';

      try {
        await gourmetService.markDeliveryOrderAsCanceled({
          deliveryOrderId: orderId,
          notes,
        });

        showSuccessPopupDialog({
          text: 'The order has been canceled successfully.',
        });
        loadOrders(status.currentPage);
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        orderInfo.loading = false;
        orderInfo.orderId = '';
        orderInfo.message = '';
      }
    };

    const markOrderAsCompleted = async (orderId: string) => {
      const notes = await showConfirmPopupDialogWithValidation({
        text: `Mark As Completed Delivery ${orderId}?`,
        title: `Completed Delivery?`,
        input: 'textarea',
        inputPlaceholder: 'Please input reason',
        validationText: 'Please provide the reason for mark delivery as completed',
        confirmButtonText: 'Complete',
      });

      if (!notes) {
        return;
      }

      orderInfo.loading = true;
      orderInfo.orderId = orderId;
      orderInfo.message = 'Marking order as completed...';

      try {
        await gourmetService.markDeliveryOrderAsCompleted({
          deliveryOrderId: orderId,
          notes,
        });

        showSuccessPopupDialog({
          text: 'The order has been marked as completed successfully.',
        });
        loadOrders(status.currentPage);
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        orderInfo.loading = false;
        orderInfo.orderId = '';
        orderInfo.message = '';
      }
    };

    const markOrderAsDoNotCharge = async (orderId: string) => {
      const notes = await showConfirmPopupDialogWithValidation({
        text: `Mark As Do Not Charge ${orderId}?`,
        title: `Do Not Charge Delivery?`,
        input: 'textarea',
        inputPlaceholder: 'Please input reason',
        validationText: `Please provide the reason for mark delivery as do not charge`,
        confirmButtonText: 'Do Not Charge',
      });

      if (!notes) {
        return;
      }

      orderInfo.loading = true;
      orderInfo.orderId = orderId;
      orderInfo.message = 'Marking order as do not charge...';

      try {
        await gourmetService.markDeliveryOrderAsDoNotCharge({
          deliveryOrderId: orderId,
          notes,
        });

        showSuccessPopupDialog({
          text: 'The order has been marked as ‘Do Not Charge’ successfully.',
        });
        loadOrders(status.currentPage);
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        orderInfo.loading = false;
        orderInfo.orderId = '';
        orderInfo.message = '';
      }
    };

    const onChangeNotReceivedOrder = async (orderId: string, value: boolean) => {
      const order = orders.value.find((item: DeliveryOrder) => item.id === orderId);

      if (!order) {
        return;
      }

      if (value) {
        const isConfirmed = await showConfirmPopupDialog({
          text: `Mark As Is Not Received Order ${orderId}?`,
          title: 'Not Received Order?',
        });

        if (!isConfirmed) {
          order.isNotReceivedOrder = false;
          return;
        }
      }

      orderInfo.loading = true;
      orderInfo.orderId = orderId;
      orderInfo.message = 'Updating order...';

      try {
        await gourmetService.markDeliveryOrderAsNotDelivered({
          deliveryOrderId: orderId,
          isNotReceivedOrder: value,
        });

        showSuccessPopupDialog({
          text: 'The order has been updated successfully.',
        });
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
        order.isNotReceivedOrder = !value;
      } finally {
        orderInfo.loading = false;
        orderInfo.orderId = '';
        orderInfo.message = '';
      }
    };

    const showOrder = async (id: string) => {
      searchCondition.queryType = 'id';
      searchCondition.queryInfo = id;

      await loadOrders(1, orderTabs.search);
      await toggleOrder(id);

      if (orders.value.length === 1) {
        expandedOrders.value.push(orders.value[0].id);
      }
    };

    const getMapMarkers = (locationMarkers: DeliveryOrderLocationMarker[]) => {
      const markers = [];
      const start = locationMarkers.find((marker: DeliveryOrderLocationMarker) => marker.title === 'store');
      const end = locationMarkers.find((marker: DeliveryOrderLocationMarker) => marker.title === 'customer');
      const courier = locationMarkers.find((marker: DeliveryOrderLocationMarker) => marker.title === 'courier');

      if (start) {
        markers.push({
          position: { lat: start.latitude, lng: start.longitude } as GeoLocationType,
          isShow: true,
          index: 0,
          icon: '/static/img/pickup_marker.png',
        });
      }

      if (end) {
        markers.push({
          position: { lat: end.latitude, lng: end.longitude } as GeoLocationType,
          isShow: true,
          index: 1,
          icon: '/static/img/dropoff_marker.png',
        });
      }

      if (courier) {
        markers.push({
          position: { lat: courier.latitude, lng: courier.longitude } as GeoLocationType,
          isShow: true,
          index: 2,
          icon: '/static/img/car_marker.png',
        });
      }

      return markers;
    };

    const getMapCenter = (locationMarkers: DeliveryOrderLocationMarker[]) => {
      const start = locationMarkers.find((marker: DeliveryOrderLocationMarker) => marker.title === 'store');
      const end = locationMarkers.find((marker: DeliveryOrderLocationMarker) => marker.title === 'customer');
      const center: GeoLocationType = {
        lat: null,
        lng: null,
      };

      if (end) {
        center.lat = end.latitude!;
        center.lng = end.longitude!;
      } else if (start) {
        center.lat = start.latitude!;
        center.lng = start.longitude!;
      }

      return center;
    };

    const getOptions = (options: any) => {
      if (options) {
        return utils.optionsFormatter(options);
      }
      return [];
    };

    const hasUnsuccessfullyStatus = (order: DeliveryOrder) => {
      return utils.hasUnsuccessfullyStatus(order);
    };

    const isResolvedWithReOrder = (order: DeliveryOrder) => {
      return utils.isResolvedWithReOrder(order);
    };

    const isResolvedWithoutReOrder = (order: DeliveryOrder) => {
      return utils.isResolvedWithoutReOrder(order);
    };

    const isRedeliveryWithReOrder = (order: DeliveryOrder) => {
      return utils.isReorderedWithReOrder(order);
    };

    const getStoreAddress = (order: DeliveryOrder) => {
      return get(order, 'storeOrder.address.formattedAddress', '');
    };

    const getStorePhone = (order: DeliveryOrder) => {
      return get(order, 'storeOrder.phoneNumber', '');
    };

    const getRefunds = (order: DeliveryOrder) => {
      const refunds = get(order, 'orderCharge.refunds') || [];
      const totalRefunds = refunds.reduce((total: number, item: any) => total + (item.costs || 0) + (item.credits || 0), 0);
      return totalRefunds / 100;
    };

    const getDropOffName = (optionId: string) => {
      return dropOffTypeList.find((dropOffType: ListType) => dropOffType.key === optionId)?.label || '';
    };

    const showRateDeliveryOrder = async (order: DeliveryOrder) => {
      orderInfo.loading = true;
      orderInfo.orderId = order.id;
      orderInfo.message = 'Loading rate data';
      orderRateData.value = [];

      try {
        orderRateData.value = await gourmetService.getOrderRatingData(order.id);
        isShowRatingDialog.value = true;
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        orderInfo.loading = false;
      }
    };

    const onSubmitRate = async (data: OrderRateListInput[]) => {
      orderInfo.loading = true;
      orderInfo.message = 'Submitting rates...';
      isShowRatingDialog.value = false;

      try {
        const res = await gourmetService.submitOrderRate({
          id: orderInfo.orderId,
          data: { rateList: data },
        });

        if (!res) {
          return showErrorPopupDialog({
            text: 'There is an issue submitting rates',
          });
        }

        const order = orders.value.find((item: DeliveryOrder) => item.id === orderInfo.orderId);

        if (order) {
          order.rateInfo = res.rateInfo;
        }

        showSuccessPopupDialog({
          text: 'The rates have been submitted successfully.',
        });
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        resetOrderInfo();
      }
    };

    const onUpdateConfirmedMonitoringCall = async (value: boolean, order: DeliveryOrder) => {
      let notes = null;

      if (value) {
        const res = await showConfirmPopupDialogWithValidation({
          title: 'Driver Confirmed Requires Monitoring Call?',
          input: 'textarea',
          inputPlaceholder: 'Please input notes',
          confirmButtonText: 'Yes, Confirmed',
        });

        if (!res) {
          return;
        }

        notes = res;
      }

      orderInfo.loading = true;
      orderInfo.message = 'Updating Confirmed Monitoring Call...';
      orderInfo.orderId = order.id;

      try {
        await gourmetService.updateDriverConfirmedMonitoringCall({
          id: orderInfo.orderId,
          isConfirmed: value,
          notes,
        });

        const order = orders.value.find((item: DeliveryOrder) => item.id === orderInfo.orderId);

        if (order) {
          order.isConfirmedMonitoringCall = value;
        }

        showSuccessPopupDialog({
          text: 'The confirmed monitoring call has been updated successfully.',
        });
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        resetOrderInfo();
      }
    };

    const submitNeedLove = async (order: DeliveryOrder) => {
      setGourmetNeedLoveInfo({
        customerName: order.caller ? `${order.caller.firstName} ${order.caller.lastName}` : '',
        phoneNumber: order.preferredPhoneNumber || order.caller?.phoneNumber,
        callerId: order.callerId,
        restaurantName: order.storeOrder.title,
        costOfOriginalOrder: order.total || 0,
        orderId: order.id,
        vendorType: order.service === 'dd' ? GourmetVendor.dd : GourmetVendor.ue,
      });

      router.push({
        name: 'DeliveryNeedLove',
      });
    };

    const openRefund = async (order: DeliveryOrder) => {
      if (!order.transactionId) {
        return;
      }

      refundTransactionId.value = order.transactionId;
      orderInfo.orderId = order.id;
      isShowRefundDeliveryOrder.value = true;
    };

    const redeliveryOrder = (order: DeliveryOrder) => {
      setRedeliveryOrderId(order.id);
      router.push({
        name: 'ManualOrder',
      });
    };

    const onSendReceipt = async (order: DeliveryOrder) => {
      orderInfo.message = 'Sending a Receipt...';
      orderInfo.loading = true;
      orderInfo.orderId = order.id;

      try {
        const response = await sendPost('sendDeliveryReceipt', {
          orderId: order.id,
        });

        showSuccessPopupDialog({
          text: response.data.message,
        });
      } catch (error) {
        const errorText = utils.getErrorResponse(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        resetOrderInfo();
      }
    };

    const enabledEditDeliveryInstructions = (order: DeliveryOrder) => {
      if (!isAllowToManage.value) {
        return false;
      }

      return ['placed', 'preparing', 'saved', 'scheduled'].includes(order.status);
    };

    const editDeliveryInstructions = (order: DeliveryOrder) => {
      orderInfo.orderId = order.id;
      deliveryInstructionsInfo.isUpdatingDeliveryInstructions = true;
      deliveryInstructionsInfo.deliveryInstructions = order?.storeOrder?.estimate?.orderOptions?.deliveryInstructions || '';
      deliveryInstructionsInfo.dropoffOptionId = order?.storeOrder?.estimate?.orderOptions?.dropoffOptionId || dropOffTypeList[0].key;
    };

    const clearDeliveryInstructions = () => {
      deliveryInstructionsInfo.isUpdatingDeliveryInstructions = false;
      deliveryInstructionsInfo.deliveryInstructions = '';
      deliveryInstructionsInfo.dropoffOptionId = '';
      resetOrderInfo();
    };

    const resetOrderInfo = () => {
      orderInfo.orderId = '';
      orderInfo.loading = false;
      orderInfo.message = '';
    };

    const updateDeliveryInstructions = async () => {
      if (!orderInfo.orderId) {
        return;
      }

      orderInfo.loading = true;
      orderInfo.message = 'Updating Delivery Instructions...';

      try {
        await gourmetService.updateDeliveryInstructions({
          id: orderInfo.orderId,
          dropoffOptionId: deliveryInstructionsInfo.dropoffOptionId,
          deliveryInstructions: deliveryInstructionsInfo.deliveryInstructions,
        });

        const order = orders.value.find((item: DeliveryOrder) => item.id === orderInfo.orderId);

        if (order?.storeOrder?.estimate?.orderOptions) {
          order.storeOrder.estimate.orderOptions.deliveryInstructions = deliveryInstructionsInfo.deliveryInstructions;
          order.storeOrder.estimate.orderOptions.dropoffOptionId = deliveryInstructionsInfo.dropoffOptionId;
        }

        showSuccessPopupDialog({
          text: 'The delivery instructions have been updated successfully.',
        });
        clearDeliveryInstructions();
      } catch (error) {
        const errorText = utils.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        orderInfo.loading = false;
      }
    };

    const getPathForDeliverySMS = (order: DeliveryOrder) => {
      const deliveryAddress = order.storeOrder?.estimate?.address;
      const query = {
        driverNumber: order.orderStatus?.agent?.phoneNumber,
        phoneNumber: order.caller?.phoneNumber,
        operatorNumber: order.serviceAccount?.phoneNumber,
        deliveryAddress: deliveryAddress
          ? utils.getFormattedAddress({
              streetAddress: deliveryAddress.streetAddress ?? '',
              streetAddress2: deliveryAddress.streetAddress2 ?? '',
              city: deliveryAddress.city ?? '',
              state: deliveryAddress.state ?? '',
              zip: deliveryAddress.postalCode ?? '',
            })
          : '',
      };

      const queryParams = queryString.stringify(query) as string;

      const path = `/operator/delivery-sms?${queryParams}`;

      return path;
    };

    const getPathForDeliveryCall = (order: DeliveryOrder) => {
      const queryParams = queryString.stringify({
        toNumber: order.orderStatus?.agent?.phoneNumber ?? '',
        fromNumber: order?.serviceAccount?.phoneNumber ?? '',
      });

      return `/partner/delivery-orders?${queryParams}`;
    };

    const getPathForOriginalOrder = (order: DeliveryOrder) => {
      const queryParams = queryString.stringify({
        phoneNumber: order.caller.phoneNumber,
      });

      return `/partner/delivery-orders/${order.originalOrderId}?${queryParams}`;
    };

    const copyOrderLink = (order: DeliveryOrder) => {
      const orderLink = 'https://www.doordash.com/orders/' + order.orderId;
      utils.copyText(orderLink, 'Order Link');
    };

    watch(
      () => route.params.id,
      (newId?: string | string[]) => {
        if (!newId) {
          return;
        }

        if (typeof newId === 'string') {
          showOrder(newId);
        } else {
          showOrder(newId[0]);
        }
      },
    );

    watch(isNeedToShowFirstDeliveryPopup, showFirstDeliveryPopup, {
      immediate: true,
    });

    watch(
      () => searchCondition.queryType,
      (type: string) => {
        let searchInfo = '';

        if (type === 'callerId' && customerInfo.value) {
          searchInfo = customerInfo.value.id;
        }

        if (type === 'callerPhone' && customerInfo.value) {
          searchInfo = customerInfo.value.phoneNumber;
        }

        if (type === 'service') {
          searchInfo = gourmetServiceList[0].key;
        }

        if (type === 'operatorId') {
          searchInfo = (route.query?.processedOperatorId as string) || '';
        }

        if (type === 'serviceAccountId') {
          searchInfo = (route.query?.serviceAccountId as string) || '';
        }

        searchCondition.queryInfo = searchInfo;
      },
    );

    watch(customerInfo, (value: any) => {
      if (value && searchCondition.queryType === 'callerId') {
        searchCondition.queryInfo = value.id;
        loadOrders(1, orderTabs.search);
      } else if (value && searchCondition.queryType === 'callerPhone') {
        searchCondition.queryInfo = value.phoneNumber;
        loadOrders(1, orderTabs.search);
      }
    });

    onMounted(() => {
      if (route.params.id) {
        showOrder(route.params.id as string);
      } else if (route.query.processedOperatorId) {
        status.section = orderTabs.search;
        searchCondition.queryType = 'operatorId';
        loadOrders(1, orderTabs.search);
      } else if (route.query.serviceAccountId) {
        status.section = orderTabs.search;
        searchCondition.queryType = 'serviceAccountId';
        loadOrders(1, orderTabs.search);
      } else {
        searchCondition.queryType = 'callerPhone';
        searchCondition.queryInfo = customerInfo.value?.phoneNumber;
      }

      if (interval.value) {
        clearInterval(interval.value);
      }

      interval.value = setInterval(async () => {
        // to auto refresh the active orders page
        if (status.section !== orderTabs.active) {
          return;
        }

        const resp = await gourmetService.getActiveOrders({
          pagination,
        });

        if (status.section === orderTabs.active) {
          // need this check in case operator changes tab during calling getActiveOrders
          orders.value = resp.rows;
          status.totalPages = Math.ceil(resp.count / paginationLimit);
        }
      }, updateDelay);
    });

    onBeforeUnmount(() => {
      if (interval.value) {
        clearInterval(interval.value);
      }
    });

    return {
      orderTabs,
      queryTypeList,
      orders,
      expandedOrders,
      detailedOrders,
      searchCondition,
      status,
      timeSpanValue,
      utils,
      orderRateData,
      orderStatus,
      isShowRatingDialog,
      GourmetRateTarget,
      dropOffTypeList,
      deliveryInstructionsInfo,
      orderInfo,
      isShowRefundDeliveryOrder,
      refundTransactionId,
      hasSpecialPermission,
      isPhoneSearch,
      isServiceSearch,
      isDisabledSearch,
      gourmetServiceList,
      isAllowToManage,

      onUpdateConfirmedMonitoringCall,
      enabledEditDeliveryInstructions,
      updateDeliveryInstructions,
      editDeliveryInstructions,
      clearDeliveryInstructions,
      clearSearch,
      getDropOffName,
      clickSearchButton,
      getOrderedBy,
      getClientSavings,
      toggleOrder,
      loadOrders,
      doResolveOrderWithoutReorder,
      markOrderAsCanceled,
      markOrderAsCompleted,
      markOrderAsDoNotCharge,
      getMapMarkers,
      getMapCenter,
      getOptions,
      hasUnsuccessfullyStatus,
      isResolvedWithReOrder,
      isResolvedWithoutReOrder,
      isRedeliveryWithReOrder,
      getStoreAddress,
      getStorePhone,
      showRateDeliveryOrder,
      onSubmitRate,
      submitNeedLove,
      openRefund,
      onSendReceipt,
      getRefunds,
      getPathForDeliverySMS,
      onChangeNotReceivedOrder,
      getPathForDeliveryCall,
      redeliveryOrder,
      getPathForOriginalOrder,
      copyOrderLink,
    };
  },
};
</script>

<style lang="scss">
.page-content.delivery-orders {
  .el-dialog__body div {
    text-align: unset;
  }

  .map-container {
    margin-bottom: 0;
  }
  .charge-item {
    display: flex;
    .charge-title {
      flex: 1;
      display: flex;
      gap: 5px;
      align-items: center;

      .charge-info {
        color: rgb(37, 36, 34);
        border: 2px solid rgb(37, 36, 34);
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
      }
    }
    .charge-origial-value {
      text-decoration: line-through;
      color: gray;
      margin-right: 5px;
    }
  }

  .copy-link {
    color: #51cbce;
    cursor: pointer;
  }

  .copy-link:hover {
    text-decoration: underline;
    color: #51cbce;
  }

  .refund-item {
    color: red;
  }

  .items-list {
    padding-left: 15px;
  }

  .border-top {
    border-top: 1px solid #ccc;
    padding-top: 20px;
  }

  .row-map {
    margin-bottom: 0;

    .el-collapse-item div[role='tab'] {
      display: none;
    }
  }

  .send-receipt-icon,
  .order-rate-icon,
  .need-love-icon,
  .refund-icon,
  .redelivery-icon {
    cursor: pointer;
    font-size: 30px;
    margin-top: 5px;
  }

  .order-rate-icon {
    color: orange;
  }

  .send-receipt-icon {
    margin-right: 10px;
    color: #51cbce;
  }

  .need-love-icon {
    color: #ee682d;
  }

  .refund-icon {
    color: #ee682d;
    margin-left: 10px;
  }

  .redelivery-icon {
    color: #ee682d;
    margin-left: 10px;
  }

  .sections {
    text-align: center;

    button {
      opacity: 0.5;

      &.active {
        opacity: 1;
      }
    }
  }
  form.search {
    text-align: center;
    padding-top: 15px;
    border-top: 1px solid #ccc;
    margin-top: 15px;
  }

  #orders {
    .card {
      margin-bottom: 0;
    }
  }

  .capitalize {
    text-transform: capitalize;
  }

  .center {
    text-align: center;
  }
  .card-title .order-options-preloader {
    height: 125px;
    .el-loading-mask {
      background-color: #ffff !important;
    }
  }
  .btn-reorder {
    color: #fff;
  }
  .actions-area {
    border: 2px solid #ffa500;
    padding: 10px;
  }
  .order-status-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .orderBadge {
      color: #ffffff;
      padding: 4px 6px;
    }

    .resolvedOrderBudge {
      background-color: #ffa500;
    }

    .unresolvedOrderBudge {
      background-color: #ff0000;
    }
  }
  .order-details-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .rate-container {
    display: flex;
    align-items: center;

    .el-rate {
      .el-rate__icon {
        font-size: 22px;
      }
    }
  }

  .instructions-info {
    display: flex;
    strong {
      margin-top: 7px;
      margin-right: 10px;
      white-space: nowrap;
    }
  }

  .redelivery-section {
    width: 100%;
    border: 2px solid #ffa500;
    text-transform: uppercase;
    padding: 10px;
    font-size: 15px;

    p {
      text-transform: initial;
      font-size: 14px;
    }
  }
}
</style>
